import { render, staticRenderFns } from "./ps_org_password_settings_form.vue?vue&type=template&id=cf2f86fe&"
import script from "./ps_org_password_settings_form.vue?vue&type=script&lang=js&"
export * from "./ps_org_password_settings_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports